import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FieldOkItemComponent } from '@softline/dynamic';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'soft-field-ok-auftrag-list-view',
  imports: [],
  templateUrl: './auftrag.list-view.html',
  styleUrls: ['./auftrag.list-view.css'],
})
export class AuftragListView implements FieldOkItemComponent<any> {
  readonly item = input<any>();
}
